import {
  about1,
  about2,
  about3,
  about4,
  about5,
  about6,
  about7,
  about8,
} from "../../../../../images/index.js";

export const journeyData = [
  {
    img: about3,
    title: "Owners & Brand Founders",
    desc: "See your Amazon business health instantly after the payment schedule",
  },
  {
    img: about2,
    title: "Agencies",
    desc: "Manage multiple brands with clarity & confidence value (insights).",
  },
  {
    img: about1,
    title: "Managers & Executives",
    desc: "Take smarter decisions without manually digging into",
  },
  {
    img: about4,
    title: "Resellers & Distributors",
    desc: "Understand what sells, where, how, and when",
  },
];
export const journeyBelowData = [
  {
    img: about5,
    title: "Secure API",
  },
  {
    img: about6,
    title: "Seller-owned data",
  },
  {
    img: about7,
    title: "Trusted by sellers",
  },
  {
    img: about8,
    title: "Expert-backed",
  },
];